import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackEcomButtonClickEventData } from './legacy-types';

export const createLegacyTrackEcomButtonClick = (
  vehicle: ElasticVehicle,
): LegacyTrackEcomButtonClickEventData => {
  const eventData: LegacyTrackEcomButtonClickEventData = {
    eventType: 'ecomButtonClick',
    item: vehicle,
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackEcomButtonClick = () => {
  const { track } = useLegacyTracking();

  const trackLegacyEcomButtonClick = useCallback(
    (vehicle: ElasticVehicle) => {
      track({
        event: 'ecomButtonClick',
        data: createLegacyTrackEcomButtonClick(vehicle),
      });
    },
    [track],
  );

  return {
    trackLegacyEcomButtonClick,
  };
};
